import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  buttonsStyle,
  dateFormatter,
} from "../../../components/tables/table";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import {
  changBannerReloj,
  changeDestaReloj,
  changeNovedadReloj,
  changeStatusReloj,
  changeStockReloj,
  deleteReloj,
  getRelojes,
  resetRelojesStats,
  updateReloj,
} from "../../../../api/reloj";
import { getMarcas } from "../../../../api/marca";
import { getModelos } from "../../../../api/modelo";
import FiltersCard from "../../../components/filters/Filter";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Edit, VerifiedUser, Visibility } from "@material-ui/icons";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import WhatshotOutlinedIcon from "@material-ui/icons/WhatshotOutlined";
import FavoriteIcon from "@material-ui/icons/Favorite";
import { MdInventory, MdVerified } from "react-icons/md";
import { PiFlagBanner } from "react-icons/pi";
import { shallowEqual, useSelector } from "react-redux";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

function getData(relojes, marcas, modelos) {
  let data = [];
  for (let i = 0; i < relojes.length; ++i) {
    const priceAmount = parseFloat(relojes[i]?.price?.amount || 0);
    const rowId = relojes[i]?._id || relojes[i]?.id;
    const status = relojes[i]?.sold
      ? "sold"
      : relojes[i]?.pendingApproval
      ? "pending"
      : relojes[i]?.active
      ? "published"
      : "not_published";
    const statusLabel =
      status === "sold"
        ? "Vendido"
        : status === "pending"
        ? "Pendiente"
        : status === "published"
        ? "Publicado"
        : "No publicado";
    const sellerEmail =
      relojes[i]?.seller?.email ||
      relojes[i]?.seller?.name ||
      (typeof relojes[i]?.seller === "string" ? relojes[i]?.seller : "");
    
    // Obtener el modelo: puede ser un ObjectId o un objeto populado
    let modeloNombre = "";
    const relojModelo = relojes[i]?.specifications?.reloj_modelo;
    if (relojModelo) {
      if (typeof relojModelo === "object" && relojModelo.nombre) {
        // Ya está populado
        modeloNombre = relojModelo.nombre;
      } else {
        // Es un ObjectId, buscar en el array de modelos
        const modeloId = typeof relojModelo === "object" && relojModelo._id 
          ? relojModelo._id.toString() 
          : relojModelo.toString();
        const modeloEncontrado = modelos.find((m) => {
          const mId = m._id ? m._id.toString() : m.toString();
          return mId === modeloId;
        });
        modeloNombre = modeloEncontrado?.nombre || "";
      }
    }
    if (!modeloNombre) {
      const rawNombre = relojes[i]?.data?.specifications?.reloj_modelo;
      if (typeof rawNombre === "string" && rawNombre.trim()) {
        modeloNombre = rawNombre.trim();
      }
    }
    
    // Obtener el nombre de la marca: puede ser un ObjectId o un objeto populado
    let marcaNombre = "";
    const relojBrand = relojes[i]?.brand;
    
    // Log temporal para depurar
    if (i === 0) {
      console.log(`[DEBUG FRONTEND] Primer reloj brand:`, relojBrand);
      console.log(`[DEBUG FRONTEND] Tipo de brand:`, typeof relojBrand);
      console.log(`[DEBUG FRONTEND] Brand tiene nombre?:`, relojBrand?.nombre);
    }
    
    if (relojBrand) {
      // Verificar si es un objeto populado con nombre
      if (typeof relojBrand === "object" && relojBrand.nombre) {
        // Ya está populado, usar directamente el nombre
        marcaNombre = relojBrand.nombre;
      } else if (typeof relojBrand === "object" && relojBrand.$oid) {
        // Es un ObjectId en formato MongoDB (con $oid)
        const brandId = relojBrand.$oid.toString();
        const marcaEncontrada = marcas.find((x) => {
          const xId = x._id ? (x._id.$oid ? x._id.$oid.toString() : x._id.toString()) : x.toString();
          return xId === brandId;
        });
        marcaNombre = marcaEncontrada?.nombre || "";
      } else {
        // Es un ObjectId normal o string, buscar en el array de marcas
        const brandId = typeof relojBrand === "object" && relojBrand._id 
          ? (relojBrand._id.$oid ? relojBrand._id.$oid.toString() : relojBrand._id.toString())
          : (relojBrand.$oid ? relojBrand.$oid.toString() : relojBrand.toString());
        const marcaEncontrada = marcas.find((x) => {
          const xId = x._id ? (x._id.$oid ? x._id.$oid.toString() : x._id.toString()) : x.toString();
          return xId === brandId;
        });
        marcaNombre = marcaEncontrada?.nombre || "";
      }
    }
    
    const elem = {
      id: rowId,
      referencia: relojes[i]?.specifications?.n_mero_de_referencia ?? "",
      sku: relojes[i]?.sku,
      views: relojes[i]?.views ?? 0,
      likes: relojes[i]?.likes ?? 0,
      marca: marcaNombre,
      modelo: modeloNombre,
      createdAt: relojes[i]?.createdAt,
      precio: priceAmount
        ? priceAmount.toLocaleString("es-ES", { style: "currency", currency: "EUR" })
        : "",
      aprobacion: statusLabel,
      aprobacionStatus: status,
      pendingApproval: relojes[i]?.pendingApproval,
      active: relojes[i]?.active,
      sold: relojes[i]?.sold || false,
      vendedor: sellerEmail,
    };
    data.push(elem);
  }
  return data;
}

// Slug para URL de producto en la web (mismo criterio que turelojya-web)
function slugify(text) {
  if (!text) return "";
  return String(text)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}
function getProductSlug(row) {
  const id = row?.id ?? row?._id;
  if (!id) return "";
  const parts = [slugify(row.marca), slugify(row.modelo)].filter(Boolean);
  if (row.sku) parts.push(slugify(row.sku));
  parts.push(String(id));
  return parts.join("-");
}

const initialFilters = {
  marcas: [],
  vendedores: [],
  desde: null,
  hasta: null,
  usado: null,
  sku: "",
  skuExact: false, // Si es true, busca SKU exacto; si es false, busca flexible (como ahora)
  referencia: "", // Número de referencia (specifications.n_mero_de_referencia)
  estado: "", // "pending", "published", "sold", "not_published", o "" para todos
  destacado: "", // "", "true", "false"
  novedad: "", // "", "true", "false"
  visitasDesde: null,
  visitasHasta: null,
  origin: "", // "" para todos, o un valor específico de origin
};

function SectionTitle({ children, first }) {
  return (
    <Typography
      variant="subtitle1"
      style={{
        fontWeight: 600,
        marginTop: first ? 0 : 24,
        marginBottom: 12,
        color: "#374151",
        borderBottom: "1px solid #e5e7eb",
        paddingBottom: 6,
      }}
    >
      {children}
    </Typography>
  );
}

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function RelojesPage() {
  // Helper: normalize and deduplicate items client-side to avoid visual duplicates
  const normalize = (s) => {
    if (s === undefined || s === null) return "";
    return String(s).toLowerCase().trim().replace(/\s+/g, " ");
  };

  const canonicalKey = (item) => {
    const sku = normalize(item?.sku);
    const material = normalize(item?.specifications?.material_de_la_caja);
    const esfera = normalize(item?.specifications?.esfera);
    const diam = normalize(item?.specifications?.di_metro);
    return `${sku}|${material}|${esfera}|${diam}`;
  };

  const uniqueByCanonical = (items) => {
    const seen = new Set();
    const out = [];
    for (const it of items || []) {
      const k = canonicalKey(it);
      if (!seen.has(k)) {
        seen.add(k);
        out.push(it);
      }
    }
    return out;
  };
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  
  // Obtener lista única de vendedores de los datos
  const getVendedores = () => {
    const vendedoresSet = new Set();
    data.forEach((reloj) => {
      const sellerEmail =
        reloj?.seller?.email ||
        reloj?.seller?.name ||
        (typeof reloj?.seller === "string" ? reloj?.seller : "");
      if (sellerEmail) {
        vendedoresSet.add(sellerEmail);
      }
    });
    return Array.from(vendedoresSet).sort();
  };

  // Obtener lista única de origins de los datos
  // Incluir también los origins posibles aunque no estén en los datos cargados
  const getOrigins = () => {
    const originsSet = new Set();
    // Primero agregar los origins posibles según el modelo
    const possibleOrigins = ["chrono24", "manual", "wordpress", "TuRelojYa", "other"];
    possibleOrigins.forEach(origin => originsSet.add(origin));
    
    // Luego agregar los que están en los datos cargados (por si hay alguno nuevo)
    data.forEach((reloj) => {
      const origin = reloj?.origin;
      if (origin) {
        originsSet.add(origin);
      }
    });
    return Array.from(originsSet).sort();
  };

  // Mapear origin a etiqueta legible
  const getOriginLabel = (origin) => {
    const labels = {
      chrono24: "Chrono24",
      manual: "Manual",
      wordpress: "WordPress",
      TuRelojYa: "TuRelojYa",
      other: "Otro",
    };
    return labels[origin] || origin;
  };
  const [reloj, setReloj] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [bulkUnpublishLoading, setBulkUnpublishLoading] = useState(false);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  const [selectedRows, setSelectedRows] = useState([]);
  const [resetStatsDialogOpen, setResetStatsDialogOpen] = useState(false);
  const [resettingStats, setResettingStats] = useState(false);
  const history = useHistory();
  const classes = useStyles();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const badgeFormatter = (cell, row) => {
    const status = row.aprobacionStatus;
    const base = {
      padding: "4px 12px",
      borderRadius: "999px",
      fontWeight: 600,
      color: "#0f172a",
      display: "inline-block",
    };
    if (status === "pending" || status === "not_published") {
      return (
        <span
          style={{
            ...base,
            backgroundColor: "#facc15",
            color: "#111827",
          }}
        >
          {status === "pending" ? "Pendiente" : "No publicado"}
        </span>
      );
    }
    if (status === "sold") {
      return (
        <span
          style={{
            ...base,
            backgroundColor: "#ef4444",
            color: "#ffffff",
          }}
        >
          Vendido
        </span>
      );
    }
    return (
      <span
        style={{
          ...base,
          backgroundColor: "#60a5fa",
          color: "#0b1e43",
        }}
      >
        Publicado
      </span>
    );
  };

  const columns = [
    {
      dataField: "referencia",
      text: "Nº ref.",
      sort: true,
      headerStyle: { width: "80px" },
      style: { whiteSpace: "normal", wordBreak: "break-word" },
    },
    {
      dataField: "sku",
      text: "SKU",
      sort: true,
      headerStyle: { width: "80px" },
      style: { whiteSpace: "normal", wordBreak: "break-word" },
    },
    { dataField: "marca", text: "Marca", sort: true, headerStyle: { width: "110px" } },
    { dataField: "modelo", text: "Modelo", sort: true, headerStyle: { width: "120px" } },
    {
      dataField: "precio",
      text: "Precio",
      sort: true,
      headerStyle: { width: "90px" },
      style: { whiteSpace: "normal" },
    },
    {
      dataField: "createdAt",
      text: "CreatedAt",
      sort: true,
      formatter: dateFormatter,
      headerStyle: { width: "140px" },
      style: { whiteSpace: "normal" },
    },
    {
      dataField: "vendedor",
      text: "Vendedor (email)",
      sort: true,
      headerStyle: {
        width: "140px",
        maxWidth: "160px",
        textAlign: "left",
      },
      style: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        textAlign: "left",
      },
    },
    {
      dataField: "aprobacion",
      text: "Aprobación",
      sort: true,
      formatter: badgeFormatter,
      headerStyle: {
        width: "90px",
        minWidth: "90px",
        textAlign: "center",
        paddingLeft: 2,
        paddingRight: 2,
      },
      style: {
        textAlign: "center",
        paddingLeft: 2,
        paddingRight: 2,
      },
    },
    {
      dataField: "views",
      text: "Visitas",
      sort: true,
      formatter: (cell) => {
        const viewsCount = cell ?? 0;
        let iconColor = "#9e9e9e"; // Gris por defecto (0 visitas)
        if (viewsCount > 100) {
          iconColor = "#2196f3"; // Azul si tiene más de 100 visitas
        } else if (viewsCount > 0) {
          iconColor = "#757575"; // Gris oscuro si tiene entre 1 y 100 visitas
        }
        return (
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            <Visibility style={{ fontSize: 18, opacity: 0.8, color: iconColor }} />
            {viewsCount}
          </span>
        );
      },
      headerStyle: {
        width: "36px",
        minWidth: "36px",
        textAlign: "center",
        paddingLeft: 0,
        paddingRight: 0,
      },
      style: { textAlign: "center", paddingLeft: 0, paddingRight: 0 },
    },
    {
      dataField: "likes",
      text: "Me gusta",
      sort: true,
      formatter: (cell) => {
        const likesCount = cell ?? 0;
        const iconColor = likesCount > 0 ? "#e91e63" : "#9e9e9e"; // Rojo si tiene likes, gris si es 0
        return (
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            <FavoriteIcon style={{ fontSize: 18, opacity: 0.8, color: iconColor }} />
            {likesCount}
          </span>
        );
      },
      headerStyle: {
        width: "36px",
        minWidth: "36px",
        textAlign: "center",
        paddingLeft: 0,
        paddingRight: 0,
      },
      style: { textAlign: "center", paddingLeft: 0, paddingRight: 0 },
    },
    {
      dataField: "id",
      text: "Acciones",
      formatter: buttonFormatter,
      headerStyle: {
        width: "70px",
        minWidth: "70px",
        textAlign: "center",
        paddingLeft: 4,
        paddingRight: 4,
      },
      style: { textAlign: "center", paddingLeft: 4, paddingRight: 4 },
    },
  ];

  function buttonFormatter(cell, row) {
    // row = fila transformada (getData) con marca, modelo, sku, id. elem = reloj crudo del API
    const cellId = normalizeId(
      cell ||
        (typeof cell === "object" && cell?.id) ||
        (typeof cell === "object" && cell?._id)
    );
    const elem = data.find((item) => normalizeId(item?._id || item?.id) === cellId);

    const handleDeleteClick = () => {
      const id = normalizeId(elem?._id || elem?.id || cellId);
      if (!id) {
        alertError({ customMessage: "No se pudo determinar el ID del reloj para eliminar." });
        return;
      }
      setReloj(elem);
      setOpenConfirmDialog(2);
    };

    const handleFeatureClick = () => {
      const id = normalizeId(elem?._id || elem?.id || cellId);
      if (!id) {
        alertError({ customMessage: "No se pudo determinar el ID del reloj para destacar." });
        return;
      }
      setReloj(elem);
      setOpenConfirmDialog(4);
    };

    const handleNovedadClick = () => {
      const id = normalizeId(elem?._id || elem?.id || cellId);
      if (!id) {
        alertError({ customMessage: "No se pudo determinar el ID del reloj para novedad." });
        return;
      }
      setReloj(elem);
      setOpenConfirmDialog(7);
    };

    const webBase = process.env.REACT_APP_WEB_URL || process.env.WEB_URL || "https://www.turelojya.com";
    const productSlug = getProductSlug(row || elem);
    const productUrl = productSlug ? `${webBase}/producto/${productSlug}` : null;

    return (
      <div style={{ display: "flex", justifyContent: "center", gap: 3, padding: "0 2px" }}>
        <Tooltip title="Ver en la web (temporal)">
          <Button
            style={{ ...buttonsStyle, color: "#1976d2" }}
            size="small"
            onClick={() => productUrl && window.open(productUrl, "_blank", "noopener,noreferrer")}
            disabled={!productUrl}
          >
            <OpenInNewIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-reloj/" + cell)}
          >
            <Edit />
          </Button>
        </Tooltip>
        <Tooltip title={elem?.destacado ? "Quitar destacado" : "Destacar"}>
          <Button
            style={{
              ...buttonsStyle,
              color: elem?.destacado ? "#f59e0b" : undefined,
            }}
            size="small"
            onClick={handleFeatureClick}
            disabled={!cellId}
          >
            {elem?.destacado ? <StarIcon /> : <StarBorderIcon />}
          </Button>
        </Tooltip>
        <Tooltip title={elem?.novedad ? "Quitar novedad" : "Marcar como novedad"}>
          <Button
            style={{
              ...buttonsStyle,
              color: elem?.novedad ? "#3b82f6" : undefined,
            }}
            size="small"
            onClick={handleNovedadClick}
            disabled={!cellId}
          >
            {elem?.novedad ? <WhatshotIcon /> : <WhatshotOutlinedIcon />}
          </Button>
        </Tooltip>
        {user?.role === "admin" && (
          <Tooltip title="Delete">
            <Button
              style={buttonsStyle}
              size="small"
              onClick={handleDeleteClick}
              disabled={!cellId}
            >
              <DeleteIcon />
            </Button>
          </Tooltip>
        )}
      </div>
    );
  }

  useEffect(() => {
    setLoading(true);
    getMarcas()
      .then((res) => {
        if (res.status === 200) {
          setMarcas(res.data);
        }
      })
      .catch((error) => {
        setLoading(false);
        alertError({ error: error, customMessage: "Could not get marcas." });
      });
    // Cargar modelos para poder mostrar los nombres
    getModelos({ page: 1, limit: 1000, filters: {} })
      .then((res) => {
        if (res.status === 200) {
          const modelosData = Array.isArray(res.data) 
            ? res.data 
            : Array.isArray(res.data?.data) 
              ? res.data.data 
              : [];
          setModelos(modelosData);
        }
      })
      .catch((error) => {
        console.error("Error loading modelos:", error);
        // No mostrar error crítico, solo log
      });
    // showAll=true para traer activos, inactivos y pendientes
    // origin!=manual: excluir relojes importados manualmente (solo se usan en Scraping/Tasación)
    // limit=500 para traer una cantidad razonable sin exceder memoria de MongoDB
    getRelojes({ filters: { showAll: true, origin: "not-manual" }, page: 1, limit: 500 })
      .then((res) => {
        if (res.status === 200) {
          // Backend puede devolver array directo o paginado {data:[], total...}
          const raw = Array.isArray(res.data)
            ? res.data
            : Array.isArray(res.data?.data)
              ? res.data.data
              : [];
          const deduped = (raw || []).map((r) => {
            const status = r.sold
              ? "sold"
              : r.pendingApproval
              ? "pending"
              : r.active
              ? "published"
              : "not_published";
            const statusLabel =
              status === "sold"
                ? "Vendido"
                : status === "pending"
                ? "Pendiente"
                : status === "published"
                ? "Publicado"
                : "No publicado";
            return {
              ...r,
              aprobacion: statusLabel,
              aprobacionStatus: status,
              seller: r.seller || null, // Asegurar que seller esté disponible
            };
          });
          // Ordenar: primero pendientes, luego publicados, luego vendidos
          deduped.sort((a, b) => {
            const order = { pending: 0, published: 1, sold: 2, not_published: 3 };
            return (order[a.aprobacionStatus] ?? 4) - (order[b.aprobacionStatus] ?? 4);
          });
          setData(deduped);
          setFilteredData(deduped);
          setLoading(false);
          setRefresh(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        alertError({ error: error, customMessage: "Could not get relojes." });
      });
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    let newFilteredData = data;
    if (filterOptions.desde !== "" && filterOptions.desde !== null) {
      newFilteredData = newFilteredData.filter(
        (x) => parseFloat(x.price?.amount) >= filterOptions.desde
      );
    }
    if (filterOptions.hasta !== "" && filterOptions.hasta !== null) {
      newFilteredData = newFilteredData.filter(
        (x) => parseFloat(x.price?.amount) <= filterOptions.hasta
      );
    }

    if (filterOptions.sku !== "" && filterOptions.sku !== null) {
      if (filterOptions.skuExact) {
        // Búsqueda exacta
        newFilteredData = newFilteredData.filter(
          (x) => String(x.sku || "").trim() === String(filterOptions.sku).trim()
        );
      } else {
        // Búsqueda flexible: el SKU contiene el texto buscado
        const skuSearch = String(filterOptions.sku).toLowerCase().trim();
        newFilteredData = newFilteredData.filter(
          (x) => String(x.sku || "").toLowerCase().includes(skuSearch)
        );
      }
    }

    // Filtro por número de referencia (flexible: contiene el texto)
    if (filterOptions.referencia !== "" && filterOptions.referencia != null) {
      const refSearch = String(filterOptions.referencia).toLowerCase().trim();
      newFilteredData = newFilteredData.filter((x) => {
        const ref = (x?.specifications?.n_mero_de_referencia ?? "").toString().toLowerCase().trim();
        return ref.includes(refSearch);
      });
    }

    if (
      filterOptions.vendedores &&
      filterOptions.vendedores.length > 0
    ) {
      newFilteredData = newFilteredData.filter((x) => {
        const sellerEmail =
          x?.seller?.email ||
          x?.seller?.name ||
          (typeof x?.seller === "string" ? x?.seller : "");
        return filterOptions.vendedores.includes(sellerEmail);
      });
    }

    if (filterOptions.usado === true) {
      newFilteredData = newFilteredData.filter(
        (x) => x.specifications.estado?.usado
      );
    }

    if (filterOptions?.marcas?.length > 0) {
      // Normalizar IDs de marca seleccionados (pueden venir como objeto {_id} o string)
      const listIds = new Set(
        filterOptions.marcas.map((x) =>
          x ? normalizeId(x._id || x) : ""
        )
      );
      // Normalizar también el campo brand de cada reloj (puede ser ObjectId o objeto populado)
      newFilteredData = newFilteredData.filter((x) => {
        const brandId =
          x?.brand && typeof x.brand === "object" && x.brand._id
            ? normalizeId(x.brand._id)
            : normalizeId(x?.brand);
        return listIds.has(brandId);
      });
    }

    // Filtro por estado (Pendiente/No publicado/Publicado/Vendido)
    if (filterOptions.estado !== "" && filterOptions.estado !== null) {
      newFilteredData = newFilteredData.filter((x) => {
        const status = x.sold
          ? "sold"
          : x.pendingApproval
          ? "pending"
          : x.active
          ? "published"
          : "not_published";
        // Unificar "pending" y "not_published" como "pending" (ambos son no publicados)
        if (filterOptions.estado === "pending") {
          return status === "pending" || status === "not_published";
        }
        return status === filterOptions.estado;
      });
    }

    // Filtro por destacado
    if (filterOptions.destacado !== "" && filterOptions.destacado !== null) {
      const destacadoValue = filterOptions.destacado === "true";
      newFilteredData = newFilteredData.filter((x) => x.destacado === destacadoValue);
    }

    // Filtro por novedad
    if (filterOptions.novedad !== "" && filterOptions.novedad !== null) {
      const novedadValue = filterOptions.novedad === "true";
      newFilteredData = newFilteredData.filter((x) => x.novedad === novedadValue);
    }

    // Filtro por visitas (rango)
    if (filterOptions.visitasDesde !== "" && filterOptions.visitasDesde !== null) {
      newFilteredData = newFilteredData.filter(
        (x) => (x.views || 0) >= parseFloat(filterOptions.visitasDesde)
      );
    }
    if (filterOptions.visitasHasta !== "" && filterOptions.visitasHasta !== null) {
      newFilteredData = newFilteredData.filter(
        (x) => (x.views || 0) <= parseFloat(filterOptions.visitasHasta)
      );
    }

    // Filtro por origin
    if (filterOptions.origin !== "" && filterOptions.origin !== null) {
      newFilteredData = newFilteredData.filter(
        (x) => (x.origin || "chrono24") === filterOptions.origin
      );
    }

    setFilteredData(newFilteredData);
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const handleResetStats = async () => {
    try {
      setResettingStats(true);
      const response = await resetRelojesStats();
      if (response.status === 200) {
        alertSuccess({
          customMessage: "Estadísticas restablecidas correctamente. Todas las visitas y me gusta han sido puestas a 0.",
        });
        setResetStatsDialogOpen(false);
        setRefresh(true);
      } else {
        alertError({
          customMessage: "Error al restablecer las estadísticas.",
        });
      }
    } catch (error) {
      console.error("Error al restablecer estadísticas:", error);
      alertError({
        error: error,
        customMessage: "Error al restablecer las estadísticas.",
      });
    } finally {
      setResettingStats(false);
    }
  };

  const normalizeId = (val) => {
    if (!val) return "";
    if (typeof val === "object" && val._id) return String(val._id);
    return String(val);
  };

  const handlePublishAll = async () => {
    if (user?.role !== "admin") return;
    
    // Si no hay relojes seleccionados, no hacer nada
    if (!selectedRows || selectedRows.length === 0) {
      alertError({ customMessage: "Por favor, selecciona al menos un reloj para publicar." });
      return;
    }
    
    // Publicar solo los relojes seleccionados que no estén claramente publicados
    const toPublish = selectedRows
      .map((d) => ({ ...d, _normalizedId: normalizeId(d._id || d.id) }))
      .filter(
        (d) =>
          d._normalizedId &&
          (d.active !== true || d.pendingApproval !== false)
      );
    if (!toPublish.length) {
      alertSuccess({ customMessage: "Los relojes seleccionados ya están publicados." });
      return;
    }
    try {
      setBulkLoading(true);
      await Promise.all(
        toPublish.map((item) =>
          updateReloj(item._normalizedId, {
            active: true,
            pendingApproval: false,
          })
        )
      );
      // Optimistic update local
      setData((prev) =>
        prev.map((r) =>
          toPublish.find((t) => t._normalizedId === normalizeId(r._id || r.id))
            ? { ...r, active: true, pendingApproval: false, aprobacionStatus: "published", aprobacion: "Publicado" }
            : r
        )
      );
      setFilteredData((prev) =>
        prev.map((r) =>
          toPublish.find((t) => t._normalizedId === normalizeId(r._id || r.id))
            ? { ...r, active: true, pendingApproval: false, aprobacionStatus: "published", aprobacion: "Publicado" }
            : r
        )
      );
      alertSuccess({ customMessage: `${toPublish.length} reloj(es) se han publicado correctamente.` });
      setSelectedRows([]); // Limpiar selección
      setRefresh(true);
    } catch (error) {
      alertError({ error, customMessage: "No se pudieron publicar los relojes seleccionados." });
    } finally {
      setBulkLoading(false);
    }
  };

  const handleUnpublishAll = async () => {
    if (user?.role !== "admin") return;
    
    // Si no hay relojes seleccionados, no hacer nada
    if (!selectedRows || selectedRows.length === 0) {
      alertError({ customMessage: "Por favor, selecciona al menos un reloj para despublicar." });
      return;
    }
    
    // Despublicar solo los relojes seleccionados que no estén claramente active=false
    const toUnpublish = selectedRows
      .map((d) => ({ ...d, _normalizedId: normalizeId(d._id || d.id) }))
      .filter(
        (d) =>
          d._normalizedId &&
          d.active !== false
      );
    if (!toUnpublish.length) {
      alertSuccess({ customMessage: "Los relojes seleccionados ya están despublicados." });
      return;
    }
    try {
      setBulkUnpublishLoading(true);
      await Promise.all(
        toUnpublish.map((item) =>
          updateReloj(item._normalizedId, {
            active: false,
            pendingApproval: false,
          })
        )
      );
      // Optimistic update local
      setData((prev) =>
        prev.map((r) =>
          toUnpublish.find((t) => t._normalizedId === normalizeId(r._id || r.id))
            ? { ...r, active: false, pendingApproval: false, aprobacionStatus: "not_published", aprobacion: "No publicado" }
            : r
        )
      );
      setFilteredData((prev) =>
        prev.map((r) =>
          toUnpublish.find((t) => t._normalizedId === normalizeId(r._id || r.id))
            ? { ...r, active: false, pendingApproval: false, aprobacionStatus: "not_published", aprobacion: "No publicado" }
            : r
        )
      );
      alertSuccess({ customMessage: `${toUnpublish.length} reloj(es) se han marcado como no publicados.` });
      setSelectedRows([]); // Limpiar selección
      setRefresh(true);
    } catch (error) {
      alertError({ error, customMessage: "No se pudieron despublicar los relojes seleccionados." });
    } finally {
      setBulkUnpublishLoading(false);
    }
  };

  const handleApprove = async (item) => {
    const id = normalizeId(item?._id || item?.id);
    if (!id) {
      alertError({ customMessage: "No se pudo determinar el ID para aprobar." });
      return;
    }
    try {
      await updateReloj(id, { active: true, pendingApproval: false });
      alertSuccess({ customMessage: "Reloj aprobado y publicado." });
      setRefresh(true);
    } catch (error) {
      alertError({ error, customMessage: "No se pudo aprobar el reloj." });
    }
  };

  const handleReject = async (item) => {
    const id = normalizeId(item?._id || item?.id);
    if (!id) {
      alertError({ customMessage: "No se pudo determinar el ID para rechazar." });
      return;
    }
    try {
      await updateReloj(id, { active: false, pendingApproval: false });
      alertSuccess({ customMessage: "Reloj marcado como rechazado (inactivo)." });
      setRefresh(true);
    } catch (error) {
      alertError({ error, customMessage: "No se pudo rechazar el reloj." });
    }
  };

  const renderFiltersContent = () => {
    return (
      <>
        <SectionTitle first>SKU y número de referencia</SectionTitle>
        <div className="row d-flex align-items-center">
          <div className="col-md-3">
            <TextField
              id="sku"
              label="SKU"
              type="text"
              value={filterOptions.sku || ""}
              onChange={(event) => {
                setFilterOptions({
                  ...filterOptions,
                  sku: event.target.value,
                });
              }}
              fullWidth
              variant="outlined"
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className="col-md-3">
            <InputLabel>SKU Exacto:</InputLabel>
            <FormControlLabel
              control={
                <Switch
                  checked={filterOptions.skuExact}
                  onChange={() =>
                    setFilterOptions({
                      ...filterOptions,
                      skuExact: !filterOptions.skuExact,
                    })
                  }
                  name="skuExact"
                />
              }
              label={filterOptions.skuExact ? "Exacto" : "Flexible"}
            />
          </div>
          <div className="col-md-3">
            <TextField
              id="referencia"
              label="Número de referencia"
              type="text"
              value={filterOptions.referencia || ""}
              onChange={(event) => {
                setFilterOptions({
                  ...filterOptions,
                  referencia: event.target.value,
                });
              }}
              fullWidth
              variant="outlined"
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Ej: 18038"
            />
          </div>
        </div>

        <SectionTitle>Precio y condición</SectionTitle>
        <div className="row d-flex align-items-center">
          <div className="col-md-3">
            <TextField
              id="precioDesde"
              label="Precio Desde"
              type="number"
              value={filterOptions.desde || ""}
              onChange={(event) => {
                setFilterOptions({
                  ...filterOptions,
                  desde: event.target.value,
                });
              }}
              fullWidth
              variant="outlined"
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className="col-md-3">
            <TextField
              id="precioHasta"
              label="Precio Hasta"
              type="number"
              value={filterOptions.hasta || ""}
              onChange={(event) => {
                setFilterOptions({
                  ...filterOptions,
                  hasta: event.target.value,
                });
              }}
              fullWidth
              variant="outlined"
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className="col-md-3">
            <InputLabel>Usado:</InputLabel>
            <FormControlLabel
              control={
                <Switch
                  checked={filterOptions.usado}
                  onChange={() =>
                    setFilterOptions({
                      ...filterOptions,
                      usado: !filterOptions.usado,
                    })
                  }
                  name="Usado"
                />
              }
              label={filterOptions.usado ? "Usado" : "All"}
            />
          </div>
        </div>

        <SectionTitle>Marca, vendedor y estado</SectionTitle>
        <div className="row d-flex align-items-center">
          <div className="col-md-4">
            <Autocomplete
              className="w-100 mr-5"
              id="autocomplete-marca"
              filterSelectedOptions
              options={marcas}
              getOptionLabel={(option) => option?.nombre}
              value={filterOptions.marcas}
              onChange={(event, selected) => {
                setFilterOptions({ ...filterOptions, marcas: selected });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Marca"
                />
              )}
              multiple
            />
          </div>
          <div className="col-md-4">
            <Autocomplete
              className="w-100 mr-5"
              id="autocomplete-vendedor"
              filterSelectedOptions
              options={getVendedores()}
              getOptionLabel={(option) => option || ""}
              value={filterOptions.vendedores}
              onChange={(event, selected) => {
                setFilterOptions({
                  ...filterOptions,
                  vendedores: selected,
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Vendedor"
                />
              )}
              multiple
            />
          </div>
          <div className="col-md-4">
            <FormControl fullWidth margin="normal" variant="outlined">
              <InputLabel id="estado-label" shrink={true}>Estado</InputLabel>
              <Select
                labelId="estado-label"
                value={filterOptions.estado || ""}
                onChange={(event) => {
                  setFilterOptions({
                    ...filterOptions,
                    estado: event.target.value,
                  });
                }}
                displayEmpty
                label="Estado"
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="pending">Pendiente/No publicado</MenuItem>
                <MenuItem value="published">Publicado</MenuItem>
                <MenuItem value="sold">Vendido</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        <SectionTitle>Destacado, novedad y visitas</SectionTitle>
        <div className="row d-flex align-items-center">
          <div className="col-md-3">
            <FormControl fullWidth margin="normal" variant="outlined">
              <InputLabel id="destacado-label" shrink={true}>Destacado</InputLabel>
              <Select
                labelId="destacado-label"
                value={filterOptions.destacado || ""}
                onChange={(event) => {
                  setFilterOptions({
                    ...filterOptions,
                    destacado: event.target.value,
                  });
                }}
                displayEmpty
                label="Destacado"
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="true">Sí</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-md-3">
            <FormControl fullWidth margin="normal" variant="outlined">
              <InputLabel id="novedad-label" shrink={true}>Novedad</InputLabel>
              <Select
                labelId="novedad-label"
                value={filterOptions.novedad || ""}
                onChange={(event) => {
                  setFilterOptions({
                    ...filterOptions,
                    novedad: event.target.value,
                  });
                }}
                displayEmpty
                label="Novedad"
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="true">Sí</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-md-3">
            <TextField
              id="visitasDesde"
              label="Visitas Desde"
              type="number"
              value={filterOptions.visitasDesde || ""}
              onChange={(event) => {
                setFilterOptions({
                  ...filterOptions,
                  visitasDesde: event.target.value || null,
                });
              }}
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className="col-md-3">
            <TextField
              id="visitasHasta"
              label="Visitas Hasta"
              type="number"
              value={filterOptions.visitasHasta || ""}
              onChange={(event) => {
                setFilterOptions({
                  ...filterOptions,
                  visitasHasta: event.target.value || null,
                });
              }}
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </div>

        <SectionTitle>Origen</SectionTitle>
        <div className="row d-flex align-items-center">
          <div className="col-md-3">
            <FormControl fullWidth margin="normal" variant="outlined">
              <InputLabel id="origin-label" shrink={true}>Origen</InputLabel>
              <Select
                labelId="origin-label"
                value={filterOptions.origin || ""}
                onChange={(event) => {
                  setFilterOptions({
                    ...filterOptions,
                    origin: event.target.value,
                  });
                }}
                displayEmpty
                label="Origen"
              >
                <MenuItem value="">Todos</MenuItem>
                {getOrigins().map((origin) => (
                  <MenuItem key={origin} value={origin}>
                    {getOriginLabel(origin)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista Relojes">
          <CardHeaderToolbar>
            {selectedRows.length > 0 && (
              <>
                <Button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setOpenConfirmDialog(6)}
                  startIcon={<DeleteIcon />}
                  style={{ marginRight: 10 }}
                >
                  Borrar seleccionados ({selectedRows.length})
                </Button>
                {user?.role === "admin" && (
                  <>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handlePublishAll}
                      disabled={bulkLoading || !data.length}
                      style={{ marginRight: 10 }}
                    >
                      {bulkLoading ? "Publicando..." : `Publicar seleccionados (${selectedRows.length})`}
                    </Button>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleUnpublishAll}
                      disabled={bulkUnpublishLoading || !data.length}
                      style={{ marginRight: 10 }}
                    >
                      {bulkUnpublishLoading ? "Despublicando..." : `Despublicar seleccionados (${selectedRows.length})`}
                    </Button>
                  </>
                )}
              </>
            )}
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setResetStatsDialogOpen(true)}
              disabled={resettingStats}
              style={{ marginRight: "10px" }}
            >
              {resettingStats ? "Restableciendo..." : "Restablecer estadísticas"}
            </Button>
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-reloj")}
            >
              Add
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <FiltersCard
            filtersContent={renderFiltersContent}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleClearFilters={handleClearFilters}
            handleSearch={handleSearch}
          />
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <CircularProgress className={classes.fancyLoader} />
            </div>
          ) : (
            <Table
              data={getData(filteredData, marcas, modelos)}
              columns={columns}
              onSelectionChange={setSelectedRows}
              selected={selectedRows}
              allFilteredData={getData(filteredData, marcas, modelos)}
            />
          )}
          <ConfirmDialog
            title={`Are you sure you want to ${reloj?.active ? "disable" : "enable"
              } this admin?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusReloj(reloj?._id, !reloj?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${reloj?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `Admin ${reloj?.active ? "disabled" : "enabled"
                        } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${reloj?.active ? "disable" : "enable"
                      } admin.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this admin?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              const deleteId = normalizeId(reloj?._id || reloj?.id);
              if (!deleteId) return;
              deleteReloj(deleteId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Admin removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove admin.",
                  });
                });
            }}
          />
          <ConfirmDialog
            title={`Are you sure you want to ${reloj?.stock ? "out of stock" : "stock"
              } this watch?`}
            open={openConfirmDialog === 3}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStockReloj(reloj?._id, !reloj?.stock)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${reloj?.stock ? "Disabled!" : "Enabled!"}`,
                      customMessage: `Watch ${reloj?.stock ? "out of stock" : "in stock"
                        } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${reloj?.stock ? "out of stock" : "in stock"
                      } watch.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={`Are you sure you want to ${reloj?.destacado ? "unfeatured" : "feature"
              } this watch?`}
            open={openConfirmDialog === 4}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeDestaReloj(reloj?._id, !reloj?.destacado)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${reloj?.destacado ? "Featured!" : "Unfeatured!"
                        }`,
                      customMessage: `Watch ${reloj?.destacado ? "unfeatured" : "Featured"
                        } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${reloj?.destacado ? "unfeatured" : "featured"
                      } watch.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={`Are you sure you want to ${reloj?.banner ? "unfeatured" : "feature"
              } this watch?`}
            open={openConfirmDialog === 5}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changBannerReloj(reloj?._id, !reloj?.banner)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${reloj?.banner ? "Featured!" : "Unfeatured!"}`,
                      customMessage: `Watch ${reloj?.banner ? "unfeatured" : "Featured"
                        } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${reloj?.banner ? "unfeatured" : "featured"
                      } watch.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={`Are you sure you want to ${reloj?.novedad ? "remove from" : "add to"
              } novedades this watch?`}
            open={openConfirmDialog === 7}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeNovedadReloj(reloj?._id, !reloj?.novedad)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${reloj?.novedad ? "Removed!" : "Added!"}`,
                      customMessage: `Watch ${reloj?.novedad ? "removed from" : "added to"
                        } novedades successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${reloj?.novedad ? "remove from" : "add to"
                      } novedades watch.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={`¿Estás seguro de que quieres borrar ${selectedRows.length} reloj(es)?`}
            open={openConfirmDialog === 6}
            setOpen={setOpenConfirmDialog}
            onConfirm={async () => {
              try {
                // Borrar todos los elementos seleccionados
                const deletePromises = selectedRows.map((row) => {
                  const deleteId = normalizeId(row.id);
                  return deleteId ? deleteReloj(deleteId) : Promise.resolve();
                });
                await Promise.all(deletePromises);
                
                alertSuccess({
                  title: "Eliminados!",
                  customMessage: `${selectedRows.length} reloj(es) eliminado(s) correctamente.`,
                });
                setSelectedRows([]);
                setRefresh(true);
              } catch (error) {
                alertError({
                  error: error,
                  customMessage: "Error al eliminar los relojes seleccionados.",
                });
              }
            }}
          />
          <ConfirmDialog
            title="¿Estás seguro de que quieres restablecer todas las estadísticas?"
            message="Esta acción pondrá todas las visitas y me gusta de todos los relojes a 0. Esta acción no se puede deshacer."
            open={resetStatsDialogOpen}
            setOpen={setResetStatsDialogOpen}
            onConfirm={handleResetStats}
          />
        </CardBody>
      </Card>
    </>
  );
}
